import ajax from "../lib/ajax";
const { default: DBStorage } = require("../lib/DBStorage");

class UserManagementService {
  async getUserTable() {
    try {
      const result = await ajax.get("/users/getAllUsers?usertype=JH");
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getUserSession() {
    try {
      const user = await DBStorage.get("user");
      const userGroup = user.user_group;
      const result = await ajax.get(
        `/users/getUserGroupSession?usergroup=${userGroup}`
      );

      return result;
    } catch (error) {
      throw error;
    }
  }

  async verifyUser(userName) {
    try {
      const result = await ajax.get(
        `/users/validateUserName/userName/${userName}`
      );
      return result;
    } catch (error) {
      throw error;
    }
  }

  async submitUser(userData) {
    try {
      const result = await ajax.post("/users/saveUser", userData);
      return result;
    } catch (error) {
      throw error;
    }
  }

  async editUser(userdata) {
    try {
      const result = await ajax.post("/users/updateUser", {
        userData: userdata,
      });
      return result;
    } catch (error) {
      throw error;
    }
  }

  async validateUser(userData) {
    try {
      const result = await ajax.post("/users/userValidation", {
        userData: userData,
      });
      return result;
    } catch (error) {
      throw error;
    }
  }

  async resetPassword(resetData) {
    try {
      const result = await ajax.post("/users/passwordUpdate", {
        userData: resetData,
      });
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteUser(userData) {
    try {
      const result = await ajax.post("/users/deleteUser", {
        userData: userData,
      });
      return result;
    } catch (error) {
      throw error;
    }
  }
}

const usermanagementservice = new UserManagementService();
export default usermanagementservice;
